import GoToAction from "@/helpers/push/actions/GoToAction";
import PushNotificationActionCreator from "@/helpers/push/creators/PushNotificationActionCreator";
export default class GoToActionCreator extends PushNotificationActionCreator {
    routeName;
    constructor(payload) {
        super();
        this.routeName = payload.routeName;
    }
    create() {
        return new GoToAction(this.routeName);
    }
}
